import React, {createRef, useEffect} from 'react'
import FJSliderInput from "../../../common/component/slider/FJSliderInput";
import styles from './FJAdjustItem.module.less'

function FJAdjustItem(props) {

  const {sliderColor, itemKey, name, min, max, value, callback, disabled} = props;
  const slider = createRef();
  const handleChange = (data) => {callback(itemKey, data)};
  useEffect(() => {
    slider.current.updateSlider(Math.floor(value));
  });
  return (
    <div className={styles.box}>
      <FJSliderInput sliderColor={sliderColor}
                     hasMedian={min !== 0}
                     disabled={disabled}
                     ref={slider}
                     name={name}
                     callback={handleChange}
                     min={min}
                     max={max}/>
    </div>
  );
}

export default FJAdjustItem;